import React from 'react';
import { createRoot } from "react-dom/client";
import Schedule from '@tnw-next/schedule';

function EventSchedule(props) {
    return (
        <div className="container">
            <Schedule eventSlug={props.eventSlug} />
        </div>
    );
}

export default EventSchedule;

let schedule = document.querySelector("#schedule");
if(schedule){
    let slug = schedule.dataset.eventScheduleSlug
    const root = createRoot(schedule);
    root.render(<EventSchedule eventSlug={slug} />)
}